function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: flex-start;\n  ",
        " {\n    flex-basis: 100%;\n    margin-bottom: 10px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  display: inline-block;\n  margin: 0 1px;\n  padding: 7px 20px 7px 0;\n  font-weight: 500;\n  font-size: 14px;\n  color: #888;\n\n  margin-right: 25px;\n\n  :last-child {\n    margin-right: 0;\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n\n  ",
        " {\n    flex-basis: 100%;\n    justify-content: center;\n    margin-top: 20px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  > i {\n    margin-right: 8px;\n  }\n  :last-child {\n    margin-left: 4px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  display: block;\n  font-weight: 500;\n  padding: 8px;\n  background: ",
        ";\n  margin: 0 auto;\n  border-radius: 3px;\n  text-align: center;\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  border-radius: 8px;\n  background: #fff;\n  margin: 30px 0;\n  padding: 50px;\n  text-align: center;\n  box-shadow: #e1e2e5 0 0 21px -3px;\n  > h4 {\n    font-size: 16px;\n    font-weight: 400;\n    margin-bottom: 20px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
import styled from 'styled-components';
import { Button } from 'Shared/Button';
import { mediaBreakpointDown } from 'Shared/Utility';
export var statValueStyles = {
    fontSize: 'xl',
    fontWeight: 'normal',
    color: 'gray.700',
    letterSpacing: 'tight',
    m: 0
};
export var SurveyResults = styled.div(_templateObject());
export var Header = styled.div(_templateObject1());
export var HeaderLeft = styled.div(_templateObject2(), mediaBreakpointDown('md'));
export var Metric = styled.div(_templateObject3());
export var HeaderRight = styled.div(_templateObject4(), mediaBreakpointDown('md'));
export var ActionButton = styled(Button)(_templateObject5());
export var Body = styled.div(_templateObject6());
export var Feasibility = styled.div(_templateObject7(), function(props) {
    return props.feasible ? '#DED' : '#EBB';
});
export var Panel = styled.div(_templateObject8());
